
    import { signInWithGoogle, onAuthChange, signOutUser } from "./jsScripts/firebase.js";

    const accountButton = document.getElementById("accountButton");
    const accountMenu = document.getElementById("accountMenu");
    const accountEmail = document.getElementById("accountEmail");
    const signOutButton = document.getElementById("signOutButton");
    let signedInUser = null;
    let busy = false;

    const closeMenu = () => {
      accountMenu.hidden = true;
      accountButton.setAttribute("aria-expanded", "false");
    };

    accountButton.addEventListener("click", async (e) => {
      e.stopPropagation();
      if (signedInUser) {
        const open = accountMenu.hidden;
        accountMenu.hidden = !open;
        accountButton.setAttribute("aria-expanded", open ? "true" : "false");
        return;
      }
      if (busy) return;
      busy = true;
      accountButton.disabled = true;
      try {
        await signInWithGoogle();
      } catch (err) {
        if (!err || err.code !== "auth/cancelled-popup-request") {
          console.error("Sign-in failed:", err);
          alert("Sign-in failed. Please try again.");
        }
      } finally {
        busy = false;
        accountButton.disabled = false;
      }
    });

    signOutButton.addEventListener("click", async () => {
      closeMenu();
      try {
        await signOutUser();
      } finally {
        // Leave for the landing page rather than redrawing this one as a guest,
        // so it is obvious the session ended and whose data is on screen.
        window.location.href = "index.html";
      }
    });

    document.addEventListener("click", (e) => {
      if (!accountMenu.hidden && !e.target.closest(".header-right")) closeMenu();
    });

    onAuthChange((user) => {
      signedInUser = user;
      closeMenu();
      if (user) {
        accountButton.textContent = user.displayName || user.email || "Account";
        accountButton.title = user.email || "";
        accountEmail.textContent = user.email || "";
      } else {
        accountButton.textContent = "Sign in";
        accountButton.title = "Sign in to save your grades to your account";
        accountEmail.textContent = "";
      }
    });
  